export default __webpack_public_path__ + "static/media/sc.6767d221.svg";